import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Tope del lado del cliente, más estricto que el 30/minute del backend.
// Evita que un componente en loop de errores (ej. falla en cada render)
// dispare una llamada a /api/error-logs por cada error sin control.
const RATE_LIMIT_WINDOW_MS = 60_000;
const RATE_LIMIT_MAX = 10;
let sentAt = [];

function underRateLimit() {
  const now = Date.now();
  sentAt = sentAt.filter((t) => now - t < RATE_LIMIT_WINDOW_MS);
  if (sentAt.length >= RATE_LIMIT_MAX) return false;
  sentAt.push(now);
  return true;
}

export function reportError({ error_message, stack_trace, endpoint, extra_context } = {}) {
  if (!error_message) return;
  if (!underRateLimit()) return;
  axios.post(`${API}/error-logs`, {
    error_message: String(error_message).slice(0, 5000),
    stack_trace: stack_trace ? String(stack_trace).slice(0, 20000) : null,
    endpoint: endpoint || window.location.pathname,
    extra_context: extra_context || null,
  }).catch(() => {}); // reportar un error nunca debe generar un error visible nuevo
}
